module.exports = __webpack_public_path__ + "static/media/baseline-calc-24px-purple.8f6bfc7e.svg";